<template>
  <v-container fluid class="pa-0">
    <v-overlay :value="isLoading" absolute>
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64" :width="5" />
        <span class="my-4">กำลังโหลดข้อมูล</span>
      </div>
    </v-overlay>

    <ContactUsBanner />
    <ContactUsForm ref="contactForm" @submit="handleContactSubmit" />


  </v-container>
</template>

<script>
import ContactUsBanner from "@/components/ContactUs/ContactUsBanner.vue";
import ContactUsForm from "@/components/ContactUs/ContactUsForm.vue";

import { createContactApi } from "@/services/api/contactServices";
import swalAlert from "@/services/alert/swalServices";

export default {
  name: "Contactus",
  components: { ContactUsBanner, ContactUsForm },
  data() {
    return { isLoading: false };
  },
  methods: {
    async handleContactSubmit(payload) {
      this.isLoading = true;
      try {
        const { success, message, data } = await createContactApi(payload);
        const who = data?.userId
          ? `ผู้ส่ง (userId): ${data.userId}`
          : "ผู้เยี่ยมชม";

        if (success) {
          await swalAlert.Success("ส่งข้อความสำเร็จ", `${message}\n${who}`);
          this.$refs.contactForm?.resetForm?.();
        }
      } catch (err) {
        const msg =
          err?.response?.data?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง";
        await swalAlert.Error("ส่งข้อความไม่สำเร็จ", msg);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-container {
  padding: 0 !important;
}
</style>
